export default "__VITE_ASSET__D_Gxtuqs__"